import React from 'react'
import { IProps } from './index'

export const MediaByBreakpoint = ({
  mobileMedia,
  tabletMedia,
  desktopMedia,
  desktopLargeMedia,
}: IProps): React.ReactElement => {
  const getMobileMediaRules = () => {
    if (tabletMedia) return '(max-width: 767px)'
    else if (desktopMedia) return '(max-width: 1023px)'
    else if (desktopLargeMedia) return '(max-width: 1439px)'
    else return '(min-width: 0px)'
  }

  const getTabletMediaRules = () => {
    if (desktopMedia) return '(min-width: 768px) and (max-width: 1023px)'
    else if (desktopLargeMedia) return '(min-width: 768px) and (max-width: 1439px)'
    else return '(min-width: 768px)'
  }

  const getDesktopMediaRules = () => {
    if (desktopLargeMedia) return '(min-width: 1024px) and (max-width: 1439px)'
    else return '(min-width: 1024px)'
  }

  return (
    <div className="media-by-breakpoint" data-testid="media-by-breakpoint">
      {mobileMedia && <div className="media-by-breakpoint__mobile-media">{mobileMedia}</div>}
      {tabletMedia && <div className="media-by-breakpoint__tablet-media">{tabletMedia}</div>}
      {desktopMedia && <div className="media-by-breakpoint__desktop-media">{desktopMedia}</div>}
      {desktopLargeMedia && (
        <div className="media-by-breakpoint__desktop-large-media">{desktopLargeMedia}</div>
      )}

      <style jsx>{`
        .media-by-breakpoint {
          &__mobile-media,
          &__tablet-media,
          &__desktop-media,
          &__desktop-large-media {
            display: none;
          }
        }

        @media ${getMobileMediaRules()} {
          .media-by-breakpoint__mobile-media {
            display: block;
          }
        }

        @media ${getTabletMediaRules()} {
          .media-by-breakpoint__tablet-media {
            display: block;
          }
        }

        @media ${getDesktopMediaRules()} {
          .media-by-breakpoint__desktop-media {
            display: block;
          }
        }

        @media (min-width: 1440px) {
          .media-by-breakpoint__desktop-large-media {
            display: block;
          }
        }
      `}</style>
    </div>
  )
}
